<template>
  <div v-if="showConsent" class="container fixed-bottom">
    <div class="row shadow p-3 mb-3 mx-1 bg-white rounded bg-white">
      <div class="col-sm-8 col-md-8 d-flex align-content-center">
        <div class="mb-auto mt-auto">
          This site uses cookies to improve your experience.
        </div>
      </div>
      <div class="col-sm-4 col-md-4 text-right">
        <button class="btn btn-primary m-1" @click="accept">
          Accept
        </button>
        <router-link to="/cookies" class="btn btn-primary m-1">
          Read More
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        showConsent: true
      }
    },
    created() {
      this.showConsent = localStorage.cookiesAccepted !== null ? !localStorage.cookiesAccepted : true
    },
    methods: {
      accept() {
        localStorage.cookiesAccepted = true
        this.showConsent = false
      }
    }
  }
</script>
